import React from "react";
import "./index.scss";
import { Box, Grid, Typography } from "@mui/material";
import SIMPSON_OWNER_IMG from "../../../../resources/images/simpson-owner.png";
import IMG1 from "../../../../resources/images/overview-img1.png";
import IMG2 from "../../../../resources/images/overview-img2.png";

const Page1ForCarousal = () => {
  return (
    <div className="carousal-con page-load">
      <Grid container>
        <Grid item md={3} sx={{ display: "flex", justifyContent: "center" }}>
          <img src={SIMPSON_OWNER_IMG} alt="simpson owner" />
        </Grid>
        <Grid
          item
          md={9}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pr: 10,
          }}
        >
          <Typography variant="h5" className="primary-text" sx={{ mb: 2 }}>
            Simpsons - Overview
          </Typography>
          <Typography
            variant="body2"
            className="primary-text"
            sx={{ mb: 1, mt: 1 }}
          >
            Simpsons is perhaps one of the oldest business establishments in the
            country. Simpsons was the first Indian company to indigenously
            manufacture diesel engines for surface transport vehicles. Today it
            is India's leading manufacturer of high-performance diesel engines
            catering to a wide variety of applications ranging from 10 to 136
            BHP covering agriculture, industrial, power generation and marine
            applications. Simpsons today is one of the largest independent
            diesel engine manufacturers in India and manufactured over 3 million
            engines.
          </Typography>
          <Typography
            variant="body2"
            className="primary-text"
            sx={{ mb: 1, mt: 1, width: "100%" }}
          >
            Simpson Products are very well accepted in exports meeting EU Stage
            V European and TIER 4F North American Markets.
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              width: "100%",
              mt: 5,
            }}
          >
            <div>
              <Typography variant="h6">Mechanical Engines</Typography>
              <Box sx={{ display: "flex", mt: 2 }}>
                <div>
                  <Typography variant="body1">EPA</Typography>
                  <Typography variant="body1">Tier3 EU </Typography>
                  <Typography variant="body1">Stage 3,3A </Typography>
                  <Typography variant="body1">Trem3A</Typography>
                  <Typography variant="body1">BS3CEV</Typography>
                </div>
                <img src={IMG1} alt="Mechanical Engines" />
              </Box>
            </div>
            <div>
              <Typography variant="h6">Electronic Engines</Typography>
              <Box sx={{ display: "flex", mt: 2 }}>
                <div>
                  <Typography variant="body1">EPA</Typography>
                  <Typography variant="body1">Tier4F </Typography>
                  <Typography variant="body1">EU Stage </Typography>
                  <Typography variant="body1">3B</Typography>
                  <Typography variant="body1">Upgradeable to EU</Typography>
                  <Typography variant="body1">stage5, Trem5, BS5</Typography>

                  <Typography variant="body1">CEV</Typography>
                </div>
                <img src={IMG2} alt="Mechanical Engines" />
              </Box>
            </div>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Page1ForCarousal;
